const env = {
    frontend: "https://app.buildagraphic.com/",
    backend: "https://app.buildagraphic.com/"
};
export default env;
